export default __webpack_public_path__ + "static/our-office-130b88cabde9385413f105ac6d3a88d4.png";